import * as R from 'ramda'
import { $axios } from '../plugins/axios'

export const handleApiError = ({ dispatch, retryAuth = true, showErrorInSnackbar = true }, e) => {
  if (retryAuth && e && e.response && e.response.status === 401) {
    return dispatch('auth/refresh', null, { root: true })
  }
  let msg =
    (e && e.response && e.response.data && e.response.data.error) ||
    'Что-то пошло не так'
  if (!R.is(String, msg)) {
    try {
      msg = Object.values(msg)
        .map(String)
        .join('\n\n')
    } catch (_) {
      msg = String(msg)
    }
  }

  if (showErrorInSnackbar) {
    dispatch('snackbar/showError', { message: msg }, { root: true })
  }

  const err = new Error(msg)
  err.reason = e
  return Promise.reject(err)
}

export const apiGet = ({
  rootState,
  dispatch,
  url,
  auth = true,
  retryAuth = true,
  showErrorInSnackbar = true,
}) =>
  $axios.get(url, ...(auth
    ? [{ headers: { Authorization: rootState.auth.token } }]
    : []
  ))
    .then(response => ({
      res: response.data.result,
      total: response.data.total || null,
      status: response.status,
    }))
    .catch(e =>
      handleApiError({ dispatch, retryAuth, showErrorInSnackbar }, e)
        .then(() => apiGet({ rootState, url, auth, retryAuth: false, showErrorInSnackbar })))

export const apiPost = ({
  rootState,
  dispatch,
  url,
  data = null,
  auth = true,
  retryAuth = true,
  showErrorInSnackbar = true,
}) =>
  $axios.post(url, data, ...(auth
    ? [{ headers: { Authorization: rootState.auth.token } }]
    : []
  ))
    .then(response => ({
      res: response.data.result,
      total: response.data.total || null,
      status: response.status,
    }))
    .catch(e =>
      handleApiError({ dispatch, retryAuth, showErrorInSnackbar }, e)
        .then(() =>
          apiPost({ rootState, url, data, auth, retryAuth: false, showErrorInSnackbar })))
